import React, { useEffect, useRef, useState, forwardRef, useImperativeHandle } from 'react';
import { useTranslation } from 'react-i18next';

const WinnerDetails = forwardRef(({ currencyLang, isLogin, handleLoginToggle }, ref) => {
    const listRef = useRef(null);
    const [winnerList, setWinnerList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [activeButton, setActiveButton] = useState('winnersList');
    const memberListSize = 100;

    const { t } = useTranslation(['luckyWheel']);

    useEffect(() => {
        fetchData('winnersList');
    }, []);

    useEffect(() => {
        if (listRef.current) {
            const list = listRef.current;
            const scrollSpeed = 1;
            const intervalTime = 20;

            const autoScroll = () => {
                if (list.scrollTop + list.clientHeight >= list.scrollHeight) {
                    list.scrollTop = 0;
                } else {
                    list.scrollTop += scrollSpeed;
                }
            };

            const scrollInterval = setInterval(autoScroll, intervalTime);
            return () => clearInterval(scrollInterval);
        }
    }, [winnerList]);

    const fetchData = async (type = activeButton) => {
        if (loading) return;
        setLoading(true);
        setError(null);

        try {
            let result;
            if (type === 'winnersList') {
                result = await window.SPL_Member.getTodayWinnerList(window.merchantCode, currencyLang);
                result = result?.reverse() || [];
            } else if (type === 'winningRecord') {
                result = await window.SPL_Member.getMemberWinningRecord(memberListSize, currencyLang);
            }
            setWinnerList(result);
        } catch {
            setError(t(`luckyWheel.${type}Error`, 'Failed to fetch data'));
        } finally {
            setLoading(false);
        }
    };

    useImperativeHandle(ref, () => ({
        refreshData: () => fetchData(activeButton),
    }));

    const renderWinnerList = () => {
        if (loading) return <p>{t('luckyWheel.loading', 'Loading...')}</p>;
        if (error) return <p style={{ color: 'red' }}>{error}</p>;
        if (winnerList.length === 0) return <p className='empty-winner-list'>{t('luckyWheel.noWinners', 'No winners available at the moment.')}</p>;
        return (
            <table>
                <tbody>
                    {winnerList.map((item, index) => (
                        <tr key={`${item.memberLogin}-${index}`}>
                            <td>{new Date(item.spinDate).toLocaleDateString()}</td>
                            <td>
                                {item.memberLogin}
                                <span>{item.reward}</span>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    };

    return (
        <div className='winner-details'>
            <div className='winner-details-btn-container'>
                <button
                    className={`list-btn ${activeButton === 'winnersList' ? 'active' : ''}`}
                    onClick={() => {
                        setActiveButton('winnersList');
                        fetchData('winnersList');
                    }}
                    disabled={loading}
                >
                    {t('luckyWheel.winnerList')}
                </button>
                <button
                    className={`record-btn ${activeButton === 'winningRecord' ? 'active' : ''} `}
                    onClick={() => {
                        if (!isLogin) {
                            handleLoginToggle();
                            return;
                        } else {
                            setActiveButton('winningRecord');
                            fetchData('winningRecord');
                        }
                    }}
                    disabled={loading}
                >
                    {t('luckyWheel.winningRecord')}
                </button>
            </div>
            <div className='winner-list-container' ref={listRef}>
                {renderWinnerList()}
            </div>
        </div>
    );
});

export default WinnerDetails;
